
<div class="jumbotron text-center"
     *ngIf="!hasResult">
  <h4>
    El usuario {{user.user}} no está asignado a ninguna carnicería.
  </h4>
</div>
